module.exports = __webpack_public_path__ + "static/media/email.94af93a6.svg";